import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { TypographyPattern } from '../patterns';
import { BACKGROUND_COLORS } from '../tokens';
import { createResolveColor } from '../utils';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(tableAnatomy.keys);

// Exports
export const Table = defineMultiStyleConfig({
  baseStyle: definePartsStyle((props) => {
    const resolveColor = createResolveColor(props);
    return {
      thead: {
        bg: resolveColor(BACKGROUND_COLORS.muted.base),
        ...TypographyPattern.variants['table-header'],
      },
      th: {
        bg: resolveColor(BACKGROUND_COLORS.muted.base),
        ...TypographyPattern.variants['table-header'],
      },
    };
  }),
});
